import PassCover from 'icons/pass-cover'
import PassLogo from 'icons/pass-logo'
import React from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { invertTextColor } from 'utils'
import { useFormikContext } from 'formik'
import { getImageURL } from 'utils'
function ApplePass({ design, pass }) {
  const { backgroundColor, logoImage, stripImage, fullName } = design?.designId
  //console.log('DESIGN', design)

  const isEnglish = (text) => {
    if (typeof text !== 'string') return true
    const cleanText = text.replace(/\s+/g, '').toLowerCase()
    return /[a-zA-Z]/g.test(cleanText)
  }
  return (
    <div className='tw-relative' style={{ maxWidth: '330px' }}>
      <div
        className='tw-visible tw-w-[330px] tw-shadow-lg tw-text-white tw-rounded-2xl'
        style={{ backgroundColor }}
      >
        <div className='tw-flex tw-flex-col tw-h-full tw-justify-between tw-pb-6'>
          <div className='tw-mt-3 tw-ml-3 tw-w-1/6'>
            {logoImage ? (
              <img class='even:tw-hidden' src={logoImage} alt='Logo'></img>
            ) : (
              <div id='default-logo' className='tw-block tw-mt-3 tw-ml-3 '>
                <PassLogo color={invertTextColor(backgroundColor)} />
              </div>
            )}
          </div>
          <div className='tw-relative'>
            <div className='tw-items-center tw-justify-center tw-overflow-hidden tw-flex tw-aspect-[1033/407] tw-my-[15px]'>
              {stripImage && (
                <img
                  class='even:tw-hidden tw-w-full'
                  src={stripImage}
                  alt='Primary strip'
                ></img>
              )}
            </div>
          </div>

          <div className='tw-mb-12'>
            <div className='tw-px-6'>
              <p
                className='tw-flex tw-justify-between tw-text-sm tw-font-extralight tw-mt-[10px]'
                style={{
                  color: invertTextColor(backgroundColor),
                  textAlign: isEnglish(design?.userId?.fullName)
                    ? 'left'
                    : 'right',
                }}
              >
                {design?.userId?.firstName && design?.userId?.lastName
                  ? 'Customer Name'
                  : 'Customer Email'}

                <div className='tw-text-sm '>
                  {' '}
                  {design?.designType == 'stamps'
                    ? 'Remaining Stamps'
                    : 'Points'}{' '}
                </div>
              </p>
              <p
                className='tw-flex tw-justify-between tw-text-1xl tw-font-extralight'
                style={{
                  color: invertTextColor(backgroundColor),
                  textAlign: isEnglish(fullName) ? 'left' : 'right',
                }}
              >
                {design?.userId?.firstName && design?.userId?.lastName
                  ? design?.userId?.fullName
                  : design?.userId?.email}

                <div className='tw-text-1xl'>
                  {' '}
                  {design?.designType == 'stamps'
                    ? design?.stamps_detail?.stamp_balance
                    : (design?.ponit_balance || 0).toFixed(2)}{' '}
                </div>
              </p>
            </div>
          </div>
          <div className='tw-bg-white tw-mx-auto tw-rounded-md tw-card-qrcode tw-max-w-[138px] tw-p-[5px]'>
            <QRCodeCanvas
              value={design?.passCode}
              title={design?.passCode}
              viewBox='0 0 53 53'
              size={128}
            />
          </div>
          <div className='tw-text-black tw-text-center tw-mt-2'>
            {design.passCode}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ApplePass
